import LazyTable from 'app/component/lazy-table';
import { formatBigDecimalIntoString } from 'app/shared/util/number-utils';
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';

const TopListTable: React.FC = () => {
  let { month } = useParams();
  const navigate = useNavigate();

  if (!month) {
    const now = new Date();
    month = now.toISOString().slice(0, 7);
  }

  const getFormattedMonth = () => {
    return month?.slice(5, 7) + '.' + month?.slice(0, 4);
  };

  const addMonths = (dateString: string, months: number): string => {
    const [year, m] = dateString.split('-').map(Number);
    const date = new Date(year, m - 1, 1); // month - 1 because Date month is 0-indexed
    date.setMonth(date.getMonth() + months);

    const newYear = date.getFullYear();
    const newMonth = String(date.getMonth() + 1).padStart(2, '0');

    return `${newYear}-${newMonth}`;
  };

  // Get previous and next months
  const previousMonth = addMonths(month, -1);
  const nextMonth = addMonths(month, 1);

  const handlePreviousMonth = () => {
    window.location.href = `/top-list/${previousMonth}`;
  };

  const handleNextMonth = () => {
    window.location.href = `/top-list/${nextMonth}`;
  };

  const formatMonthForDisplay = (monthString: string): string => {
    const [year, m] = monthString.split('-').map(Number);
    const date = new Date(year, m - 1, 1);
    return date.toLocaleDateString('sk-SK', {
      year: 'numeric',
      month: 'long',
    });
  };

  return (
    <>
      <div>
        <h3>
          <b>Top list za mesiac {getFormattedMonth()}</b>
        </h3>
        <Card>
          <div className="flex justify-content-center mb-4">
            <div className={`flex align-items-center `}>
              <Button
                icon="pi pi-chevron-left"
                className="p-button-rounded p-button-text"
                onClick={handlePreviousMonth}
                tooltip={`Ísť na ${formatMonthForDisplay(previousMonth)}`}
                tooltipOptions={{ position: 'bottom' }}
              />

              <div className="text-center min-w-max">
                <span className="text-lg font-semibold">{formatMonthForDisplay(month)}</span>
              </div>

              <Button
                icon="pi pi-chevron-right"
                className="p-button-rounded p-button-text"
                onClick={handleNextMonth}
                tooltip={`Ísť na ${formatMonthForDisplay(nextMonth)}`}
                tooltipOptions={{ position: 'bottom' }}
              />
            </div>
          </div>
        </Card>
      </div>

      {LazyTable({
        initialSortField: 'ownSum',
        initialSortDirection: 'desc',
        createUrl: '/',
        serverUrl: '/api/top-lists/' + month,
        editActionAllowed: false,
        globalFilterFields: ['name', 'insuranceCompany.name', 'productType.name'],
        searchAllowed: false,
        columns: [
          { field: 'id', header: 'ID', sortable: true },
          { field: 'agent.firstName', header: 'Prvé meno', sortable: true },
          { field: 'agent.lastName', header: 'Priezvisko', sortable: true },
          { field: 'agent.name', header: 'Názov firmy', sortable: true },
          { field: 'ownSum', header: 'Vlastná produkcia (J)', sortable: true, formatter: v => formatBigDecimalIntoString(v) },
          { field: 'groupSum', header: 'Skupinová produkcia (J)', sortable: true, formatter: v => formatBigDecimalIntoString(v) },
        ],
        additionalHeaderButtons: (
          <span>
            <b style={{ color: 'orange' }}>INFO: Top list sa prepočítava každú noc o 4:00</b>
          </span>
        ),
      })}
    </>
  );
};

export default TopListTable;
